/* ROTY theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, moneyFormat: '${{amount}}' };
  var routes = theme.routes || {};
  var root = routes.root || '/';

  /* ---------- Helpers ---------- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    // Use the shopper's currency (it changes with their country), with the code when enabled
    var cur = theme.currency;
    if (cur && cur.iso && window.Intl && Intl.NumberFormat) {
      try {
        var out = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: cur.iso, currencyDisplay: 'narrowSymbol'
        }).format(Number(cents) / 100);
        return cur.showCode ? out + ' ' + cur.iso : out;
      } catch (err) {}
    }
    var format = theme.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3000);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------- Drawers (menu, cart, filters) ---------- */

  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function openDrawer(drawer) {
    if (!drawer) return;
    $$('.drawer.is-open').forEach(function (d) { if (d !== drawer) closeDrawer(d, true); });
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', drawer);
    setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer(drawer, keepLock) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!keepLock) document.body.classList.remove('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus && !keepLock) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    var open = $('.drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      var items = $$(FOCUSABLE, $('.drawer__panel', open)).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header ---------- */

  var headerEl = $('.section-header');
  function setHeaderHeight() {
    if (headerEl) document.documentElement.style.setProperty('--header-h', headerEl.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', debounce(setHeaderHeight, 100));

  var stickyHeader = $('sticky-header');
  if (stickyHeader) {
    var onScroll = function () { stickyHeader.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Desktop dropdowns open on hover
  if (window.matchMedia('(hover: hover)').matches) {
    $$('[data-hover-details]').forEach(function (d) {
      var item = d.parentElement;
      item.addEventListener('mouseenter', function () { d.open = true; });
      item.addEventListener('mouseleave', function () { d.open = false; });
    });
  }

  // Announcement rotation
  $$('announcement-bar.announcement--rotate').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    var i = 0;
    var interval = parseInt(bar.dataset.interval, 10) || 4000;
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Search ---------- */

  var searchModal = $('#SearchModal');
  if (searchModal) {
    var searchInput = $('input[type="search"]', searchModal);
    var resultsEl = $('#PredictiveResults');
    var defaultResults = resultsEl ? resultsEl.innerHTML : '';
    var searchAbort;

    var openSearch = function () {
      lastFocus = document.activeElement;
      searchModal.hidden = false;
      document.body.classList.add('is-locked');
      setTimeout(function () { searchInput.focus(); }, 30);
    };
    var closeSearch = function () {
      searchModal.hidden = true;
      document.body.classList.remove('is-locked');
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
      if (e.target.closest('[data-search-close]')) closeSearch();
    });
    searchModal.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

    var runSearch = debounce(function () {
      var q = searchInput.value.trim();
      if (!q) { resultsEl.innerHTML = defaultResults; return; }
      if (searchAbort) searchAbort.abort();
      searchAbort = new AbortController();
      var url = (routes.predictiveSearch || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page,query' +
        '&resources[limit]=8' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, { signal: searchAbort.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var res = $('[data-predictive-results]', doc);
          resultsEl.innerHTML = res ? res.outerHTML : '';
        })
        .catch(function () {});
    }, 220);
    searchInput.addEventListener('input', runSearch);
  }

  /* ---------- Cart ---------- */

  var cartDrawer = $('#CartDrawer');

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      if (el.hasAttribute('data-cart-inner')) return;
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
    $$('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + count + ' items'); });
  }

  function renderCartDrawer(html) {
    if (!cartDrawer || !html) return;
    var doc = parseHTML(html);
    var fresh = $('[data-cart-inner]', doc);
    var current = $('[data-cart-inner]', cartDrawer);
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCartCount(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
    }
  }

  function refreshCart() {
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) { renderCartDrawer(sections['cart-drawer']); });
  }

  function openCart() {
    if (!cartDrawer || document.body.classList.contains('template-cart')) {
      window.location.href = routes.cart || '/cart';
      return;
    }
    openDrawer(cartDrawer);
  }

  function addToCart(items) {
    return postJSON((routes.cartAdd || '/cart/add') + '.js', {
      items: items,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (data) {
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
      else refreshCart();
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      if (document.body.classList.contains('template-cart')) window.location.reload();
      else openCart();
      return data;
    });
  }

  function changeLine(key, quantity) {
    var inner = cartDrawer && $('[data-cart-inner]', cartDrawer);
    if (inner) inner.style.opacity = '.6';
    return postJSON((routes.cartChange || '/cart/change') + '.js', {
      id: key,
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (data) {
      if ($('[data-cart-page]')) { window.location.reload(); return; }
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
    }).catch(function (err) {
      if (inner) inner.style.opacity = '';
      var errEl = cartDrawer && $('[data-cart-error]', cartDrawer);
      if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      else toast(err.message);
    });
  }

  // Quick add on product cards: pick every option (e.g. colour then size), then add
  function qaState(qa) {
    var rows = $$('[data-qa-row]', qa);
    var variants = [];
    try { variants = JSON.parse($('[data-qa-variants]', qa).textContent); } catch (err) {}
    var sel = rows.map(function (r) { var p = $('[aria-pressed="true"]', r); return p ? p.dataset.qaValue : null; });
    return { rows: rows, variants: variants, sel: sel };
  }

  function qaRefresh(qa) {
    var s = qaState(qa);
    s.rows.forEach(function (r, idx) {
      $$('[data-qa-value]', r).forEach(function (b) {
        var ok = s.variants.some(function (v) {
          return v.a && v.o[idx] === b.dataset.qaValue && v.o.every(function (o, i) { return i === idx || s.sel[i] == null || o === s.sel[i]; });
        });
        b.disabled = !ok;
        if (!ok && b.getAttribute('aria-pressed') === 'true') b.setAttribute('aria-pressed', 'false');
      });
    });
    return qaState(qa);
  }

  function quickSelect(btn) {
    var qa = btn.closest('[data-quick-add]');
    var row = btn.closest('[data-qa-row]');
    var pressed = btn.getAttribute('aria-pressed') === 'true';
    $$('[data-qa-value]', row).forEach(function (b) { b.setAttribute('aria-pressed', !pressed && b === btn ? 'true' : 'false'); });
    var s = qaRefresh(qa);
    if (s.sel.some(function (v) { return v == null; })) return;
    var match = s.variants.find(function (v) { return v.o.every(function (o, i) { return o === s.sel[i]; }); });
    if (!match || !match.a) { toast('That combination is sold out.'); return; }
    btn.setAttribute('aria-busy', 'true');
    addToCart([{ id: match.id, quantity: 1 }])
      .then(function () {
        $$('[data-qa-value]', qa).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        qaRefresh(qa);
        var top = qa.closest('.card__top');
        if (top) top.classList.remove('is-open');
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && cartDrawer && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openCart();
      return;
    }

    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('cart-quantity');
      var input = $('[data-qty-input]', wrap);
      var qty = parseInt(input.value, 10) || 0;
      qty = plus ? qty + 1 : Math.max(0, qty - 1);
      var max = input.getAttribute('max');
      if (max && qty > parseInt(max, 10)) { toast('Only ' + max + ' available.'); return; }
      input.value = qty;
      changeLine(wrap.dataset.key, qty);
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0);
      return;
    }

    var qaToggle = e.target.closest('[data-qa-toggle]');
    if (qaToggle) {
      e.preventDefault();
      var top = qaToggle.closest('.card__top');
      var willOpen = !top.classList.contains('is-open');
      $$('.card__top.is-open').forEach(function (t) { t.classList.remove('is-open'); });
      top.classList.toggle('is-open', willOpen);
      qaToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    var qaValue = e.target.closest('[data-qa-value]');
    if (qaValue && !qaValue.disabled) {
      e.preventDefault();
      quickSelect(qaValue);
      return;
    }

    var quick = e.target.closest('.quick-add__size[data-variant-id]');
    if (quick && !quick.disabled) {
      e.preventDefault();
      quick.setAttribute('aria-busy', 'true');
      addToCart([{ id: parseInt(quick.dataset.variantId, 10), quantity: 1 }])
        .catch(function (err) { toast(err.message); })
        .finally(function () { quick.removeAttribute('aria-busy'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var wrap = input.closest('cart-quantity');
      changeLine(wrap.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
      return;
    }
    if (e.target.matches('[data-cart-note]')) {
      postJSON((routes.cartUpdate || '/cart/update') + '.js', { note: e.target.value }).catch(function () {});
    }
  });

  document.addEventListener('submit', function (e) {
    var upsell = e.target.closest('[data-upsell-form]');
    if (!upsell) return;
    e.preventDefault();
    var btn = $('button[type="submit"]', upsell);
    var id = parseInt(new FormData(upsell).get('id'), 10);
    btn.setAttribute('aria-busy', 'true');
    addToCart([{ id: id, quantity: 1 }])
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Product page ---------- */

  $$('product-info').forEach(function (info) {
    var section = info.dataset.section;
    var picker = $('variant-picker', info);
    var form = document.getElementById('ProductForm-' + section);
    var idInput = form && $('[data-variant-id]', form);
    var atc = form && $('[data-atc]', form);
    var atcLabel = atc && $('[data-atc-label]', atc);
    var errorEl = form && $('[data-form-error]', form);
    var dynamicCheckout = form && $('[data-dynamic-checkout]', form);
    var stockNote = $('[data-stock-note]', info);
    var notify = $('[data-notify]', info);
    var sticky = $('sticky-atc[data-section="' + section + '"]');
    var gallery = $('[data-gallery]', info);
    var variants = [];
    var current = null;

    if (picker) {
      try { variants = JSON.parse($('[data-variants]', picker).textContent); } catch (err) { variants = []; }
      if (idInput && idInput.value) {
        current = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || null;
      }
    }

    function selectedOptions() {
      return $$('fieldset', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function noun() {
      var fs = picker && $$('fieldset', picker).find(function (f) { return !$('input:checked', f); });
      if (!fs) return 'an option';
      var legend = $('legend', fs);
      var name = legend ? legend.firstChild.textContent.replace(':', '').trim().toLowerCase() : 'option';
      return name.indexOf('size') !== -1 ? 'a size' : name;
    }

    function updateAvailability(opts) {
      // Mark values unavailable given the other selected options
      $$('fieldset', picker).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var match = variants.filter(function (v) {
            return v.options.every(function (o, i) {
              if (i === idx) return o === input.value;
              return opts[i] == null || o === opts[i];
            });
          });
          var available = match.some(function (v) { return v.available; });
          var stock = match.reduce(function (n, v) { return v.available && v.inventory != null ? n + v.inventory : n; }, 0);
          var tracked = match.length && match.every(function (v) { return v.inventory != null; });
          var low = available && tracked && stock > 0 && stock <= (parseInt(stockNote && stockNote.dataset.low, 10) || 3);
          var label = input.closest('.option');
          label.classList.toggle('option--unavailable', !available);
          label.classList.toggle('option--low', !!low);
        });
      });
    }

    // Put the selected variant's photo first so shoppers see exactly what they picked
    function showVariantMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', gallery);
      if (!slide) return;
      if (slide !== gallery.firstElementChild) gallery.insertBefore(slide, gallery.firstElementChild);
      gallery.scrollTo({ left: 0 });
      var counter = $('[data-gallery-counter]', info);
      if (counter) counter.textContent = '1 / ' + gallery.children.length;
      if (window.matchMedia('(min-width: 990px)').matches) {
        var top = gallery.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 80, behavior: 'smooth' });
      }
    }

    function render() {
      var opts = selectedOptions();
      var complete = opts.every(function (o) { return o !== null; });
      current = complete ? variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null : null;

      // Selected labels
      $$('fieldset', picker).forEach(function (fs, i) {
        var lbl = $('[data-selected-label]', fs);
        if (lbl) lbl.textContent = opts[i] || 'Select';
      });
      updateAvailability(opts);

      if (idInput) idInput.value = current ? current.id : '';
      if (errorEl) errorEl.hidden = true;

      // Price
      var priceEl = $('[data-price-wrap] [data-price]', info);
      if (priceEl && current) {
        var sale = current.compare_at_price > current.price;
        priceEl.classList.toggle('price--sale', sale);
        priceEl.innerHTML = '<span class="price__current">' + formatMoney(current.price) + '</span>' +
          (sale ? '<span class="visually-hidden">Regular price</span><s class="price__compare">' + formatMoney(current.compare_at_price) + '</s>' : '');
      }

      // Button
      if (atc) {
        if (!current) {
          atc.disabled = false;
          atc.setAttribute('aria-disabled', 'false');
          atcLabel.textContent = complete ? 'Unavailable' : 'Select ' + noun();
        } else if (current.available) {
          atc.disabled = false;
          atcLabel.textContent = 'Add to cart — ' + formatMoney(current.price);
        } else {
          atc.disabled = true;
          atcLabel.textContent = 'Sold out';
        }
      }
      if (dynamicCheckout) dynamicCheckout.hidden = !(current && current.available);

      // Stock note
      if (stockNote) {
        var low = parseInt(stockNote.dataset.low, 10) || 3;
        stockNote.className = 'stock-note';
        if (!current) {
          stockNote.textContent = '';
        } else if (!current.available) {
          stockNote.classList.add('stock-note--out');
          stockNote.textContent = 'Sold out in ' + current.title;
        } else if (current.inventory != null && current.inventory <= low) {
          stockNote.classList.add('stock-note--low');
          stockNote.textContent = 'Only ' + current.inventory + ' left in ' + current.title + ' — order soon';
        } else {
          stockNote.classList.add('stock-note--in');
          stockNote.textContent = stockNote.dataset.inText || 'In stock';
        }
      }

      // Notify me
      if (notify) {
        var showNotify = !!(current && !current.available);
        if (!$('.form-message--success', notify)) notify.hidden = !showNotify;
        var vn = $('[data-notify-variant]', notify);
        if (vn && current) vn.textContent = current.title;
        var tags = $('[data-notify-tags]', notify);
        if (tags && current) {
          tags.value = 'restock-alert,restock-' + tags.dataset.handle + ',restock-variant-' + current.id;
        }
      }

      // Sticky bar
      if (sticky) {
        var sBtn = $('[data-sticky-atc]', sticky);
        var sPrice = $('[data-price]', sticky);
        if (current && sPrice) sPrice.innerHTML = '<span class="price__current">' + formatMoney(current.price) + '</span>';
        if (sBtn) sBtn.textContent = !current ? 'Select ' + noun() : current.available ? 'Add to cart' : 'Sold out';
      }

      // URL + media
      if (current) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
        if (current.media_id) showVariantMedia(current.media_id);
      }
    }

    if (picker) {
      picker.addEventListener('change', render);
      if (variants.length) updateAvailability(selectedOptions());
      if (current && current.media_id) showVariantMedia(current.media_id);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput.value) {
          if (errorEl) {
            errorEl.textContent = 'Please select ' + noun() + '.';
            errorEl.hidden = false;
          }
          var firstEmpty = picker && $$('fieldset', picker).find(function (f) { return !$('input:checked', f); });
          if (firstEmpty) {
            firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var firstInput = $('input:not([disabled])', firstEmpty);
            if (firstInput) firstInput.focus({ preventScroll: true });
          }
          return;
        }
        atc.setAttribute('aria-busy', 'true');
        var qtyInput = $('input[name="quantity"]', form);
        addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }])
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () { atc.removeAttribute('aria-busy'); });
      });
    }

    // Sticky add to cart
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        var b = $('[data-sticky-atc]', sticky);
        if (b) b.tabIndex = passed ? 0 : -1;
      });
      io.observe(atc);
      sticky.addEventListener('click', function (e) {
        if (!e.target.closest('[data-sticky-atc]')) return;
        if (current && current.available && form.requestSubmit) {
          form.requestSubmit();
        } else if (form) {
          form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    }

    // Gallery counter (mobile)
    if (gallery) {
      var counter = $('[data-gallery-counter]', info);
      var total = $$('.gallery__item', gallery).length;
      gallery.addEventListener('scroll', debounce(function () {
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
        if (counter) counter.textContent = Math.min(idx, total) + ' / ' + total;
      }, 50), { passive: true });
    }

    // Lightbox
    var lightbox = $('[data-lightbox]', info);
    if (lightbox && lightbox.showModal) {
      info.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lightbox-open]');
        if (!btn) return;
        if (window.matchMedia('(max-width: 989px)').matches) return; // swipe gallery on mobile
        var idx = parseInt(btn.getAttribute('data-lightbox-open'), 10) || 0;
        lightbox.showModal();
        var items = $$('[data-lightbox-item]', lightbox);
        if (items[idx]) items[idx].scrollIntoView({ block: 'start' });
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]') || e.target.tagName === 'IMG') lightbox.close();
      });
    }
  });

  // Show notify-me success after the page reloads
  if (/customer_posted=true/.test(window.location.search)) {
    $$('[data-notify]').forEach(function (n) {
      if ($('.form-message--success', n)) { n.hidden = false; n.scrollIntoView({ block: 'center' }); }
    });
  }

  /* ---------- Modals (size chart) ---------- */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-modal-open'));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) { var d = closer.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('modal')) e.target.close();
  });

  /* ---------- Recommendations ---------- */

  $$('product-recommendations').forEach(function (el) {
    var load = function () {
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var fresh = $('product-recommendations', doc);
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
          else el.remove();
        })
        .catch(function () {});
    };
    if (el.innerHTML.trim()) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) { obs.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  });

  /* ---------- Collection filters ---------- */

  $$('facet-filters').forEach(function (wrap) {
    var section = wrap.dataset.section;
    var baseUrl = wrap.dataset.baseUrl;
    var abort;

    function fetchResults(url, push) {
      if (abort) abort.abort();
      abort = new AbortController();
      wrap.classList.add('is-loading');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=' + section, { signal: abort.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          ['[data-facets-results]', '[data-facets-body]'].forEach(function (sel) {
            var fresh = $(sel, doc), cur = $(sel, wrap);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          var count = $('[data-results-count]', doc);
          if (count) {
            $$('[data-results-count]', wrap).forEach(function (c) { c.textContent = count.textContent; });
            var n = parseInt(count.textContent, 10);
            $$('[data-results-count-btn]', wrap).forEach(function (c) { c.textContent = isNaN(n) ? '' : n; });
          }
          applyGrid();
          if (push) window.history.pushState({ facets: true }, '', url);
          wrap.classList.remove('is-loading');
        })
        .catch(function (err) { if (err.name !== 'AbortError') wrap.classList.remove('is-loading'); });
    }

    function urlFromForm() {
      var form = $('[data-facets-form]', wrap);
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      }
      var sort = $('[data-sort]', wrap);
      if (sort) params.set('sort_by', sort.value);
      var qs = params.toString();
      return baseUrl + (qs ? '?' + qs : '');
    }

    var onFilterChange = debounce(function () { fetchResults(urlFromForm(), true); }, 350);

    wrap.addEventListener('change', function (e) {
      if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort]')) onFilterChange();
    });
    wrap.addEventListener('submit', function (e) {
      if (e.target.closest('[data-facets-form]')) { e.preventDefault(); onFilterChange(); }
    });
    wrap.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (link) {
        e.preventDefault();
        fetchResults(link.getAttribute('href'), true);
        return;
      }
      var gridBtn = e.target.closest('[data-grid]');
      if (gridBtn) {
        try { localStorage.setItem('roty_grid', gridBtn.dataset.grid); } catch (err) {}
        applyGrid();
      }
    });

    function applyGrid() {
      var cols = '4';
      try { cols = localStorage.getItem('roty_grid') || '4'; } catch (err) {}
      var grid = $('[data-product-grid]', wrap);
      if (grid) grid.setAttribute('data-cols', cols);
      $$('[data-grid]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.grid === cols ? 'true' : 'false'); });
    }
    applyGrid();

    window.addEventListener('popstate', function () { fetchResults(window.location.href, false); });
  });

  /* ---------- Signup forms (SMS via Postscript + email) ---------- */

  $$('signup-forms').forEach(function (wrap) {
    $$('[data-tab]', wrap).forEach(function (tab) {
      tab.addEventListener('click', function () {
        $$('[data-tab]', wrap).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        $$('[data-panel]', wrap).forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      });
    });
    var smsForm = $('[data-sms-form]', wrap);
    if (smsForm) {
      var frame = $('iframe', wrap);
      var submitted = false;
      smsForm.addEventListener('submit', function () {
        submitted = true;
        var b = $('button[type="submit"]', smsForm);
        if (b) b.setAttribute('aria-busy', 'true');
      });
      if (frame) {
        frame.addEventListener('load', function () {
          if (!submitted) return;
          smsForm.hidden = true;
          var ok = $('[data-sms-success]', wrap);
          if (ok) ok.hidden = false;
          var tabs = $('.signup__tabs', wrap);
          if (tabs) tabs.hidden = true;
          wrap.dispatchEvent(new CustomEvent('signup:success', { bubbles: true }));
        });
      }
    }
    if ($('[data-panel="email"] .form-message--success', wrap)) {
      $$('[data-panel]', wrap).forEach(function (p) { p.hidden = p.dataset.panel !== 'email'; });
      var t = $('.signup__tabs', wrap);
      if (t) t.hidden = true;
    }
  });

  /* ---------- Welcome popup ---------- */

  $$('welcome-popup').forEach(function (el) {
    var dialog = $('dialog', el);
    if (!dialog || !dialog.showModal) return;
    var KEY = 'roty_welcome_seen';
    var DONE = 'roty_welcome_done';
    var days = parseInt(el.dataset.days, 10) || 14;
    var preview = el.dataset.preview === 'true';
    var code = $('[data-welcome-code]', el);
    var formWrap = $('[data-welcome-form]', el);

    function store(key) { try { localStorage.setItem(key, String(Date.now())); } catch (err) {} }
    function recently(key, d) {
      try {
        var t = parseInt(localStorage.getItem(key), 10);
        return t && Date.now() - t < d * 86400000;
      } catch (err) { return false; }
    }
    function showCode() {
      if (code) code.hidden = false;
      store(DONE);
    }
    function otherPopupActive() {
      if (document.body.classList.contains('ps-scroll-lock')) return true;
      var ps = document.getElementById('ps__widget_container');
      return !!(ps && ps.querySelector('iframe') && ps.offsetParent !== null && ps.getBoundingClientRect().height > 0);
    }
    function open() {
      if (dialog.open || $('.drawer.is-open') || otherPopupActive()) return;
      dialog.showModal();
      store(KEY);
    }

    el.addEventListener('signup:success', showCode);
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-welcome-close]') || e.target === dialog) dialog.close();
    });

    // Email signup posts and reloads the page; reopen with the code
    if (formWrap && $('[data-panel="email"] .form-message--success', formWrap)) {
      showCode();
      dialog.showModal();
      return;
    }

    if (!preview && (recently(DONE, 365) || recently(KEY, days))) return;

    var delay = preview ? 300 : parseInt(el.dataset.delay, 10) || 8000;
    var timer = setTimeout(open, delay);

    // Exit intent on desktop
    if (!preview && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) {
          clearTimeout(timer);
          document.removeEventListener('mouseout', onOut);
          open();
        }
      });
    }
  });

  /* ---------- Product card photos: arrows on every device, swipe on touch ---------- */

  function setCardDot(media, idx) {
    if (!media) return;
    $$('.card__dots span', media).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }

  function cardIndex(track) {
    return Math.round(track.scrollLeft / (track.clientWidth || 1));
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-card-arrow]');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var top = arrow.closest('.card__top');
    var track = top && $('[data-card-track]', top);
    if (!track) return;
    var n = track.children.length;
    var current = typeof track._idx === 'number' ? track._idx : cardIndex(track);
    var idx = (current + parseInt(arrow.dataset.cardArrow, 10) + n) % n;
    track._idx = idx;
    // Load the next photo before scrolling to it
    var img = track.children[idx];
    if (img && img.loading === 'lazy') img.loading = 'eager';
    var target = idx * track.clientWidth;
    track.scrollTo({ left: target, behavior: 'smooth' });
    // Fallback for browsers that skip the smooth animation
    setTimeout(function () { if (Math.abs(track.scrollLeft - target) > 2) track.scrollLeft = target; }, 450);
    setCardDot(top.querySelector('[data-card-media]'), idx);
  }, true);

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.matches || !track.matches('[data-card-track]')) return;
    var i = cardIndex(track);
    if (Math.abs(track.scrollLeft - i * track.clientWidth) < 2) track._idx = i;
    setCardDot(track.closest('[data-card-media]'), i);
  }, { passive: true, capture: true });

  /* ---------- Fits & inspo gallery ---------- */

  $$('[data-fit-gallery]').forEach(function (gallery) {
    var modal = $('[data-fit-modal]', gallery);
    var body = $('[data-fit-body]', gallery);
    if (!modal || !modal.showModal) return;
    gallery.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-fit-open]');
      if (!tile) return;
      var tpl = $('template[data-fit-content]', tile.closest('.fits__item'));
      if (!tpl) return;
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      modal.showModal();
    });
  });

  // Close fit / welcome dialogs when something is added so the cart drawer is visible
  document.addEventListener('cart:added', function () {
    $$('dialog.fit-modal[open]').forEach(function (d) { d.close(); });
  });

  /* ---------- Recent purchases (real orders, anonymised) ---------- */

  (function () {
    var dataEl = document.getElementById('RecentActivity');
    var box = $('[data-recent]');
    if (!dataEl || !box) return;
    var entries = [];
    try { entries = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var maxAge = (parseInt(dataEl.dataset.maxAge, 10) || 30) * 86400000;
    var perSession = parseInt(dataEl.dataset.perSession, 10) || 2;
    var delay = parseInt(dataEl.dataset.delay, 10) || 20000;
    var KEY = 'roty_recent_shown';
    var now = Date.now();

    entries = entries.filter(function (e) {
      var t = Date.parse(e.t);
      return t && now - t >= 0 && now - t <= maxAge;
    }).sort(function (a, b) { return Date.parse(b.t) - Date.parse(a.t); });

    var shown = [];
    try { shown = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (err) {}
    entries = entries.filter(function (e) { return shown.indexOf(e.handle + e.t) === -1; });
    if (!entries.length || shown.length >= perSession) return;

    function ago(t) {
      var m = Math.round((now - Date.parse(t)) / 60000);
      if (m < 60) return 'within the last hour';
      var h = Math.round(m / 60);
      if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
      var d = Math.round(h / 24);
      if (d < 7) return d + (d === 1 ? ' day ago' : ' days ago');
      var w = Math.round(d / 7);
      return w + (w === 1 ? ' week ago' : ' weeks ago');
    }

    function busy() {
      return $('.drawer.is-open') || $('dialog[open]') || (searchModal && !searchModal.hidden) || document.body.classList.contains('ps-scroll-lock');
    }

    var hideTimer;
    function show() {
      if (shown.length >= perSession || !entries.length) return;
      if (busy()) { setTimeout(show, 8000); return; }
      var e = entries.shift();
      $('[data-recent-link]', box).href = e.url;
      var img = $('[data-recent-img]', box);
      if (e.img) { img.src = e.img; img.hidden = false; } else { img.hidden = true; }
      $('[data-recent-where]', box).textContent = 'Bought in ' + e.city;
      $('[data-recent-title]', box).textContent = e.title;
      $('[data-recent-when]', box).textContent = ago(e.t);
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-visible'); });
      shown.push(e.handle + e.t);
      try { sessionStorage.setItem(KEY, JSON.stringify(shown)); } catch (err) {}
      hideTimer = setTimeout(hide, 7000);
      if (shown.length < perSession && entries.length) setTimeout(show, 45000);
    }
    function hide() {
      clearTimeout(hideTimer);
      box.classList.remove('is-visible');
      setTimeout(function () { box.hidden = true; }, 300);
    }

    $('[data-recent-close]', box).addEventListener('click', function () {
      hide();
      shown = shown.concat(new Array(perSession).fill('x')); // stop for this visit
      try { sessionStorage.setItem(KEY, JSON.stringify(shown)); } catch (err) {}
    });
    setTimeout(show, delay);
  })();

  /* ---------- Copy buttons ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn) return;
    var text = btn.getAttribute('data-copy');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(function () {
        var prev = btn.textContent;
        btn.textContent = 'Copied';
        setTimeout(function () { btn.textContent = prev; }, 1500);
      });
    }
  });

  /* ---------- Custom element registration (for styling hooks) ---------- */

  ['sticky-header', 'menu-drawer', 'search-modal', 'cart-drawer', 'cart-quantity', 'quick-add', 'product-info', 'variant-picker', 'product-form', 'media-gallery', 'sticky-atc', 'product-recommendations', 'facet-filters', 'signup-forms', 'welcome-popup', 'announcement-bar'].forEach(function (name) {
    if (!customElements.get(name)) customElements.define(name, class extends HTMLElement {});
  });

  window.ROTY = { addToCart: addToCart, refreshCart: refreshCart, openCart: openCart, formatMoney: formatMoney };
})();
